// extracted by mini-css-extract-plugin
export default {"clickable":"TextLayout_clickable__BDZuN"};